angular.module('FlexyBeautyApp.services')
    .factory('ServiceSettingsLeCiseau_Resource', ["$resource", "$location", function ($resource, $location) {
    let baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/service', {},
        {
            get: {method: 'GET', url: baseUrl + 'rest/services/:serviceId/partner-service-settings/:basicAuthRole'},
            save: {method: 'PUT', url: baseUrl + 'rest/services/:serviceId/partner-service-settings/:basicAuthRole'},
            create: {method: 'POST', url: baseUrl + 'rest/services/:serviceId/partner-service-settings/:basicAuthRole'}
        }
    );
}]);

angular.module('FlexyBeautyApp.services').factory('ServiceSettingsLeCiseau', [
        "ServiceSettingsLeCiseau_Resource", "ServiceSettingsLeCiseauData",
    function (ServiceSettingsLeCiseau_Resource, ServiceSettingsLeCiseauData) {
        let ServiceSettingsLeCiseau = function (resource, serviceId) {
            this.serviceId = serviceId;
            this.enabled = false;//Default;
            this.linkedServiceIds = [];
            this.settings = {
                promoEnabled: false,
                marketplaceCategoryId: null,
                marketplaceSubCategoryId: null,
                marketplaceVariantId: null
            };

            if (resource !== undefined && resource != null) {
                this.loadObject(resource);
            }
            if (serviceId) {
                ServiceSettingsLeCiseauData.add(this);
            }
        };

        ServiceSettingsLeCiseau.prototype.loadObject = function (object) {
            this.enabled = object.enabled;
            this.linkedServiceIds = object.linkedServiceIds;
            this.settings = {
                promoEnabled: object.settings.promoEnabled,
                marketplaceCategoryId: object.settings.marketplaceCategoryId,
                marketplaceSubCategoryId: object.settings.marketplaceSubCategoryId,
                marketplaceVariantId: object.settings.marketplaceVariantId
            }
        };

        ServiceSettingsLeCiseau.prototype.getObjectResource = function () {
            let serviceSettingsLeCiseauResource = new ServiceSettingsLeCiseau_Resource();
            serviceSettingsLeCiseauResource.enabled = this.enabled;
            serviceSettingsLeCiseauResource.linkedServiceIds = this.linkedServiceIds;
            serviceSettingsLeCiseauResource.settings = {
                promoEnabled: this.settings.promoEnabled,
                marketplaceCategoryId: this.settings.marketplaceCategoryId,
                marketplaceSubCategoryId: this.settings.marketplaceSubCategoryId,
                marketplaceVariantId: this.settings.marketplaceVariantId
            };
            return serviceSettingsLeCiseauResource;
        };

        return ServiceSettingsLeCiseau;
    }
]);

angular.module('FlexyBeautyApp.services')
    .factory('ServiceSettingsLeCiseauSrv', ["ServiceSettingsLeCiseau_Resource", "ServiceSettingsLeCiseau", "BasicAuthRole",
    function (ServiceSettingsLeCiseau_Resource, ServiceSettingsLeCiseau, BasicAuthRole) {
        let ServiceSettingsLeCiseauSrv = {};
        ServiceSettingsLeCiseauSrv.get = function (serviceId, successFunction, errorFunction) {
            if (serviceId) {
                let serviceSettingsLeCiseauResource = new ServiceSettingsLeCiseau_Resource();
                let basicAuthRole = BasicAuthRole.LE_CISEAU_ROLE.role;
                serviceSettingsLeCiseauResource.$get(
                    {serviceId: serviceId, basicAuthRole: basicAuthRole}, //params
                    function (serviceSettingsLeCiseau) {
                        if (successFunction) {
                            successFunction(new ServiceSettingsLeCiseau(serviceSettingsLeCiseau, serviceId));
                        }
                    },
                    function (serviceSettingsLeCiseau) {
                        if (errorFunction) {
                            errorFunction();
                        }
                    });
            } else {
                if (errorFunction !== undefined) {
                    errorFunction();
                }
            }
        };

        ServiceSettingsLeCiseauSrv.save = function (serviceSettingsLeCiseau, serviceId, successFunction, errorFunction) {
            if (serviceSettingsLeCiseau) {
                let serviceSettingsLeCiseauResource = serviceSettingsLeCiseau.getObjectResource();
                let basicAuthRole = BasicAuthRole.LE_CISEAU_ROLE.role;
                serviceSettingsLeCiseauResource.$save(
                    {serviceId: serviceId, basicAuthRole: basicAuthRole}, //params
                    function () {
                        if (successFunction) {
                            successFunction();
                        }
                    },
                    function () {
                        if (errorFunction) {
                            errorFunction();
                        }
                    });
            } else {
                if (errorFunction !== undefined) {
                    errorFunction();
                }
            }
        };

        ServiceSettingsLeCiseauSrv.create = function (serviceSettingsLeCiseau, serviceId, successFunction, errorFunction) {
            if (serviceSettingsLeCiseau) {
                let serviceSettingsLeCiseauResource = serviceSettingsLeCiseau.getObjectResource();
                let basicAuthRole = BasicAuthRole.LE_CISEAU_ROLE.role;
                serviceSettingsLeCiseauResource.$create(
                    {serviceId: serviceId, basicAuthRole: basicAuthRole}, //params
                    function () {
                        if (successFunction) {
                            successFunction();
                        }
                    },
                    function () {
                        if (errorFunction) {
                            errorFunction();
                        }
                    });
            } else {
                if (errorFunction !== undefined) {
                    errorFunction();
                }
            }
        };

        return ServiceSettingsLeCiseauSrv;
    }]);

angular.module('FlexyBeautyApp.services')
    .factory('ServiceSettingsLeCiseauData', [
    function () {
        let serviceSettingsLeCiseauData = {
            serviceSettingsLeCiseau: []
        };
    
        serviceSettingsLeCiseauData.getById = function (serviceId) {
            for (let i = 0; i < this.serviceSettingsLeCiseau.length; i++) {
                if (this.serviceSettingsLeCiseau[i].serviceId === serviceId) {
                    return this.serviceSettingsLeCiseau[i];
                }
            }
            return null;
        };

        serviceSettingsLeCiseauData.getIndexOf = function (serviceSettingsLeCiseau) {
            if (serviceSettingsLeCiseau) {
                return this.serviceSettingsLeCiseau.indexOf(serviceSettingsLeCiseau);
            }
            return -1;
        };

        serviceSettingsLeCiseauData.add = function (serviceSettingsLeCiseau) {
            let serviceSettings = serviceSettingsLeCiseauData.getById(serviceSettingsLeCiseau.serviceId);
            if (serviceSettings) {
                this.serviceSettingsLeCiseau.splice(serviceSettings, 1, serviceSettingsLeCiseau);
            } else {
                this.serviceSettingsLeCiseau.push(serviceSettingsLeCiseau);
            }
            return this.serviceSettingsLeCiseau[serviceSettingsLeCiseauData.getIndexOf(serviceSettingsLeCiseau)];
        };

        return serviceSettingsLeCiseauData;
    }
]);


// WEBPACK FOOTER //
// ./js/services/models/ServiceSettingsLeCiseau.js